import { Dashboard } from "components";

const formatDate = (value) => {
  const [year, month, day] = String(value || "").slice(0, 10).split("-");
  if (!year || !month || !day) {
    return "—";
  }

  return `${day}.${month}.${year}`;
};

const formatRate = (rate) => {
  const value = Number(rate);
  if (!Number.isFinite(value)) {
    return "—";
  }

  return value.toLocaleString("pl-PL", { maximumFractionDigits: 4 });
};

const ExchangeRates = ({ exchange_rates = [] }) => {
  const rates = Array.isArray(exchange_rates) ? exchange_rates : [];

  return (
    <Dashboard header={{ title: "Kursy NBP", icon: "info" }}>
      {rates.length === 0 ? (
        <p className="p-20">Brak kursów dla tej waluty.</p>
      ) : (
        <table className="table">
          <thead className="table__head">
            <tr>
              <th>Data</th>
              <th>Kurs</th>
              <th>Źródło</th>
              <th>Tabela NBP</th>
            </tr>
          </thead>
          <tbody className="table__body table-body">
            {rates.map(({ id, date, rate, source, nbp_table_no }) => (
              <tr key={id || date}>
                <td>{formatDate(date)}</td>
                <td>{formatRate(rate)}</td>
                <td>{source || "—"}</td>
                <td>{nbp_table_no || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Dashboard>
  );
};

export default ExchangeRates;
